<template>
    <verification-process :translation-text="translationText"
                          @back="logout()"
                          mobile-dispatch="auth/sendLoginVerificationCodeForToken"
                          email-dispatch="auth/sendLoginVerificationCodeForToken"
                          otp-dispatch="auth/verifyOtpForLogin"
                          token-login
    ></verification-process>
</template>

<script>
    import VerificationProcess from "../../components/auth/VerificationProcess";

    export default {
        components: {
            VerificationProcess
        },
        name: "LoginWithToken",
        data: () => ({
            translationText: {
                verifyMobilePageText: {
                    title: 'components.verify_mobile.form_heading.login_token.title',
                    subtitle: 'components.verify_mobile.form_heading.login_token.subtitle',
                },
                verifyEmailPageText: {
                    title: 'components.verify_email.form_heading.login.title',
                    subtitle: 'components.verify_email.form_heading.login.subtitle',
                },
                verifyLoaderPageText: {
                    smsTitle: 'components.verify_loader.loader_sms_heading',
                    callTitle: 'components.verify_loader.loader_call_heading',
                    smsInfo: 'components.verify_loader.loader_sms_details',
                    callInfo: 'components.verify_loader.loader_call_details',
                    emailTitle: 'components.verify_loader.loader_email_heading',
                    emailInfo: 'components.verify_loader.loader_email_details',
                    whatsappTitle: 'components.verify_loader.loader_whatsapp_heading',
                    whatsappInfo: 'components.verify_loader.loader_whatsapp_details'
                },
                otpPageText: {
                    title: 'components.otp.form_heading.login_token.title',
                    smsSubtitle: 'components.otp.form_heading.login_token.subtitle_sms',
                    callSubtitle: 'components.otp.form_heading.login_token.subtitle_call',
                    smsAction: 'components.otp.form_actions.resend_button_text',
                    callAction: 'components.otp.form_actions.call_again_button_text',
                    emailSubtitle: 'components.otp.form_heading.login_token.subtitle_email',
                    titleEmail: 'components.otp.form_heading.login_token.title_email',
                    emailAction: 'components.otp.form_actions.send_again_button_text',
                    whatsappSubtitle: 'components.otp.form_heading.login.subtitle_whatsapp',
                    whatsappAction: 'components.otp.form_actions.resend_button_text',
                },
            }
        }),
        methods: {
            logout() {
                this.$store.dispatch('auth/logout', {clearAssessmenttoken: true, navigate: false}).then(() => {
                    this.$router.replace({name: 'Home'});
                });
            }
        },
        mounted() {
            const maskedEmail = this.$store.state.auth.maskedEmail;
            const maskedMobile = this.$store.state.auth.maskedMobile;
            if(!maskedEmail && !maskedMobile){
                this.logout();
            }
        }
    }
</script>

<style scoped>

</style>